
document.documentElement.classList.remove('no-js');

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-mobile-toggle]');
  if (!toggle) return;
  const targetId = toggle.getAttribute('aria-controls');
  const target = document.getElementById(targetId);
  if (!target) return;

  const isOpen = target.getAttribute('data-open') === 'true';
  target.setAttribute('data-open', String(!isOpen));
  toggle.setAttribute('aria-expanded', String(!isOpen));
});

document.addEventListener('change', (event) => {
  const selector = event.target.closest('[data-sort-by]');
  if (!selector) return;

  const currentUrl = new URL(window.location.href);
  currentUrl.searchParams.set('sort_by', selector.value);
  window.location.href = currentUrl.toString();
});
